import { LBtn, LFlex, LModal, LTitle } from "@components";
import MicrophoneTroubleShootWindows from "@assets/MicrophoneTroubleShootWindows.png";
import { useNavigate } from "react-router-dom";
import { NavItems } from "@helpers/navigation";
import { translate } from "react-i18nify";

export const MicTroubleshootModal = ({ onTryAgain, onGetHelp, onClose }: MicTroubleshootModalProps): JSX.Element => {
    const navigate = useNavigate();

    const handleOnClose = (): void => {
        onClose?.();
    };

    const handleOnGetHelp = (): void => {
        navigate(NavItems.Assessments.ContactFacilitator.path);
    };

    const handleOnTryAgain = (): void => {
        onTryAgain?.();
    };

    return (
        <LModal
            onClose={handleOnClose}
            footer={
                <LFlex alignCenter justifyCenter className="assessment-help-actions mb-5" row>
                    <LBtn onClick={handleOnGetHelp} isBold variation="outline">
                        {translate("assessments.deviceCheck.contactSupport")}
                    </LBtn>
                    <LBtn onClick={handleOnTryAgain} isBold>
                        {translate("assessments.deviceCheck.tryAgain")}
                    </LBtn>
                </LFlex>
            }
            fullHeight={false}
            closeOnOverlay
        >
            <LFlex alignCenter justifyCenter className="p-4">
                <LTitle color="has-text-dark-blue" size="4">
                    {translate("assessments.deviceCheck.troubleshoot.title")}
                </LTitle>
                <LFlex row>
                    <div className="content">
                        <p className="has-text-weight-bold has-text-dark-blue">
                            {translate("assessments.deviceCheck.troubleshoot.onWindowsSelect")}
                        </p>
                        <ol className="has-text-weight-bold has-text-dark-blue">
                            <li>{translate("assessments.deviceCheck.troubleshoot.start")}</li>
                            <li>{translate("assessments.deviceCheck.troubleshoot.settings")}</li>
                            <li>{translate("assessments.deviceCheck.troubleshoot.privacy")}</li>
                            <li>{translate("assessments.deviceCheck.microphone.title")}</li>
                        </ol>
                        <p style={{ maxWidth: 400 }}>
                            {translate("assessments.deviceCheck.troubleshoot.allowAccess.intro")}
                            <span className="has-text-weight-bold has-text-dark-blue">
                                {translate("assessments.deviceCheck.troubleshoot.allowAccess.device")}
                            </span>
                            {translate("assessments.deviceCheck.troubleshoot.allowAccess.select")}
                            <span className="has-text-weight-bold has-text-dark-blue">
                                {translate("assessments.deviceCheck.troubleshoot.allowAccess.change")}
                            </span>
                            {translate("assessments.deviceCheck.troubleshoot.allowAccess.makeSure")}
                            <span className="has-text-weight-bold has-text-dark-blue">
                                {translate("assessments.deviceCheck.troubleshoot.allowAccess.microphoneAccess")}
                            </span>
                            {translate("assessments.deviceCheck.troubleshoot.allowAccess.turned")}
                            <span className="has-text-weight-bold has-text-dark-blue">
                                {translate("assessments.deviceCheck.troubleshoot.allowAccess.on")}
                            </span>
                        </p>
                    </div>
                    <img src={MicrophoneTroubleShootWindows} />
                </LFlex>
            </LFlex>
        </LModal>
    );
};

interface MicTroubleshootModalProps {
    onClose?: () => void;
    onTryAgain?: () => void;
    onGetHelp?: () => void;
}
